<main class="aic-landing position-relative overflow-hidden">
  <div class="aic-landing-grid position-absolute top-0 start-0 w-100 h-100" aria-hidden="true"></div>
  <div class="aic-landing-orb aic-landing-orb-one position-absolute rounded-circle pe-none" aria-hidden="true"></div>
  <div class="aic-landing-orb aic-landing-orb-two position-absolute rounded-circle pe-none" aria-hidden="true"></div>

  <section class="container position-relative py-5">
    <div class="row align-items-center g-5 py-lg-5">
      <div class="col-lg-7">
        <div class="d-inline-flex align-items-center gap-2 text-uppercase fw-bold aic-landing-eyebrow mb-4">
          <span class="aic-landing-live-dot rounded-circle"></span>
          National education progress
        </div>

        <h1 class="aic-landing-title fw-bold mb-4">
          Department of <span>Basic Education.</span><br />
          Progress in view.
        </h1>

        <p class="aic-landing-lead mb-4">
          A focused dashboard for tracking programme progress, implementation,
          compliance, evidence completion, and achievement across the education system.
        </p>

        <div class="d-flex flex-wrap gap-3 mb-5">
          <router-link to="/login" class="btn btn-lg aic-landing-primary-btn px-4">
            Enter the platform <i class="bi bi-arrow-right ms-2"></i>
          </router-link>
          <a href="#platform-overview" class="btn btn-lg aic-landing-secondary-btn px-4">
            View focus areas
          </a>
        </div>

        <div class="row g-3 aic-landing-stats">
          <div class="col-4" v-for="stat in portfolio_stats" :key="stat.label">
            <strong class="d-block text-white">{{ stat.value }}</strong>
            <span class="d-block text-uppercase">{{ stat.label }}</span>
          </div>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="aic-landing-console">
          <div class="d-flex justify-content-between align-items-start mb-4">
            <div>
              <p class="aic-landing-console-label text-uppercase fw-bold mb-1">DBE dashboard</p>
              <h2 class="h4 text-white mb-0">National progress</h2>
            </div>
            <span class="aic-landing-status d-inline-flex align-items-center gap-2 text-uppercase fw-bold">
              <span class="rounded-circle"></span> Live
            </span>
          </div>

          <div class="aic-landing-score d-flex align-items-center justify-content-between p-3 border rounded-4 mb-4">
            <div>
              <span class="d-block text-uppercase">Mean achievement</span>
              <strong class="d-block text-white">94<span class="d-inline">%</span></strong>
            </div>
            <div class="aic-landing-score-ring d-grid align-items-center justify-content-center rounded-circle">
              <span>94</span>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-6" v-for="card in hero_cards" :key="card.key">
              <div class="aic-landing-signal d-flex align-items-center gap-3 h-100 p-3 border rounded-3">
                <i :class="card.icon"></i>
                <div>
                  <h3 class="mb-0">{{ card.label }}</h3>
                  <p class="mb-0">{{ card.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="aic-landing-activity d-flex align-items-end gap-2 px-1 mt-3">
            <span></span><span></span><span></span><span></span><span></span>
            <span></span><span></span><span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="platform-overview" class="container position-relative pb-5">
    <div class="aic-landing-feature-shell border rounded-4 p-4 p-lg-5">
      <div class="row g-4 align-items-center">
        <div class="col-lg-4">
          <p class="aic-landing-console-label text-uppercase fw-bold mb-2">Education oversight</p>
          <h2 class="text-white fw-semibold mb-0">Built for progress.<br />Designed for accountability.</h2>
        </div>
        <div class="col-lg-8">
          <div class="row g-4">
            <div class="col-md-4" v-for="feature in platform_features" :key="feature.title">
              <div class="aic-landing-feature">
                <i :class="feature.icon + ' fs-5'"></i>
                <h3 class="h6 text-white mt-3 mb-0">{{ feature.title }}</h3>
                <p class="mt-1 mb-0">{{ feature.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
